// Firebase конфигурация
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Конфигурация Firebase (замените на ваши данные)
const firebaseConfig = {
    apiKey: "AIzaSyBCtAoe7nDbat4TjoLGqbgSO9lb9dL-Xqo",
    authDomain: "analyzpro.firebaseapp.com",
    projectId: "analyzpro",
    storageBucket: "analyzpro.firebasestorage.app",
    messagingSenderId: "382809018538",
    appId: "1:382809018538:web:f8a2b4b29a849148e200d3",
    measurementId: "G-GWDKV1GF7R"
};


// Инициализация Firebase
const app = initializeApp(firebaseConfig);

// Инициализация Firestore
export const db = getFirestore(app);

// Инициализация Storage
export const storage = getStorage(app);

export default app;
